<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill-rule="evenodd" clip-rule="evenodd"><path d="M14.83 4.346C8.112 4.346 2.667 9.94 2.667 16.84c0 6.9 5.445 12.493 12.163 12.493 6.487 0 11.789-5.218 12.144-11.79h.019v-.855c0-.746-.602-1.35-1.345-1.35h-8.672V5.697c0-.746-.602-1.35-1.344-1.35h-.802zm0 10.992V6.55c-5.532 0-10.017 4.606-10.017 10.289 0 5.682 4.485 10.288 10.017 10.288 5.302 0 9.642-4.231 9.993-9.586h-8.65a1.347 1.347 0 01-1.344-1.35v-.854z"/><path d="M20.652 2.711c-.805-.226-1.567.432-1.567 1.272v8.442c0 .746.602 1.35 1.345 1.35h7.6c.798 0 1.435-.698 1.28-1.485a9.565 9.565 0 00-.169-.719c-1.125-4.033-4.094-7.265-7.91-8.673a7.66 7.66 0 00-.579-.187zm6.237 8.86c-.964-2.811-3.027-5.093-5.657-6.299v6.3h5.657z"/></g></svg>
</template>

<script>
export default {
  name: 'symbolsPieChartOutline'
}
</script>
